import { t } from '../../app/i18n';

export default {
  GENERAL: 'GENERAL',
  MANDATE: 'MANDATE',
  LOAN: 'LOAN',
  DEDUCTIONS_AGREEMENT: 'DEDUCTIONS_AGREEMENT',
  AUTOINVEST: 'AUTOINVEST',
  ALLOCATION_TRANSFER: 'ALLOCATION_TRANSFER',
  INFORMATION_LOAN_DISPOSE: 'INFORMATION_LOAN_DISPOSE',
  LOAN_DISPOSE: 'LOAN_DISPOSE',
  DEMAND_FOR_PAYMENT_FIRST: 'DEMAND_FOR_PAYMENT_FIRST',
  DEMAND_FOR_PAYMENT_SECOND: 'DEMAND_FOR_PAYMENT_SECOND',
  DEMAND_FOR_PAYMENT_THIRD: 'DEMAND_FOR_PAYMENT_THIRD',
  PAYROLL_DEDUCTIONS_REQUEST: 'PAYROLL_DEDUCTIONS_REQUEST',
  INSURANCE_APPLICATION: 'INSURANCE_APPLICATION',
  INSURANCE_CONTRACT: 'INSURANCE_CONTRACT',
  STATIC_DOCUMENT: 'STATIC_DOCUMENT',
  INSURANCE_GROUP_PA_AD_07_18: 'INSURANCE_GROUP_PA_AD_07_18',
  INSURANCE_GROUP_PA_VPP_B_07_18: 'INSURANCE_GROUP_PA_VPP_B_07_18',
  INSURANCE_IPID_25_5_FINAL: 'INSURANCE_IPID_25_5_FINAL',
  INSURANCE_OPP_ILOE: 'INSURANCE_OPP_ILOE',
  INSURANCE_ENVENT_NOTICE: 'INSURANCE_ENVENT_NOTICE',
  INSURANCE_IMPORTANT_CONDITIONS_NOTES: 'INSURANCE_IMPORTANT_CONDITIONS_NOTES',
  INSURANCE_COVERAGE_OVERVIEW: 'INSURANCE_COVERAGE_OVERVIEW',
  INSURANCE_GENERAL_CONTRACT_INFO: 'INSURANCE_GENERAL_CONTRACT_INFO',
  INSURANCE_GENERAL_CONTRACT: 'INSURANCE_GENERAL_CONTRACT',
  BANK_ACCOUNT_STATEMENT_1: 'BANK_ACCOUNT_STATEMENT_1',
  BANK_ACCOUNT_STATEMENT_2: 'BANK_ACCOUNT_STATEMENT_2',
  PAYROLL_STATEMENT_1: 'PAYROLL_STATEMENT_1',
  PAYROLL_STATEMENT_2: 'PAYROLL_STATEMENT_2',
  OTHER: 'OTHER',
  INFORMATION_OBLIGATIONS_DEBTOR: 'INFORMATION_OBLIGATIONS_DEBTOR',
  INFORMATION_OBLIGATIONS_INVESTOR: 'INFORMATION_OBLIGATIONS_INVESTOR',
};

export const translation = {
  GENERAL: t('Rámcová zmluva'),
  MANDATE: t('Príkazná zmluva'),
  MANDATE_DEBTOR: t('Záväzná žiadosť o pôžičku'),
  MANDATE_CREDITOR: t('Záväzný pokyn investovať'),
  LOAN: t('Zmluva ku pôžičke'),
  DEDUCTIONS_AGREEMENT: t('Dohoda o zrážkách zo mzdy a z iných príjmov'),
  INFORMATION_LOAN_DISPOSE: t('Oznámenie o postúpení pohľadávky'),
  LOAN_DISPOSE: t('Zmluva o postúpení pohľadávky'),
  DEMAND_FOR_PAYMENT_FIRST: t('Prvá listová upomienka'),
  DEMAND_FOR_PAYMENT_SECOND: t('Druhá listová upomienka'),
  DEMAND_FOR_PAYMENT_THIRD: t('Tretia listová upomienka'),
  PAYROLL_DEDUCTIONS_REQUEST: t('Žiadosť o vykonávanie zrážok zo mzdy dlžníka'),
  AUTOINVEST: t('Automatické investovanie'),
  ALLOCATION_TRANSFER: t('Zmluva k predaju investícií'),
  INSURANCE_APPLICATION: t('Žiadosť o zabezpečenie poistenia'),
  INSURANCE_CONTRACT: t('Zmluva o zabezpečení poistenia schopnosti splácať pôžičku'),
  STATIC_DOCUMENT: t('Statický dokument'),
  INSURANCE_GROUP_PA_AD_07_18: t('Osobitné poistné podmienky pre skupinové úrazové poistenie pre poistenie pre prípad smrti následkom úrazu'),
  INSURANCE_GROUP_PA_VPP_B_07_18: t('Všeobecné poistné podmienky pre prípad straty končatiny, zraku, sluchu alebo reči následkom úrazu, chirurgického zákroku, hospitalizácie, zlomenín a popálenín, dočasnej pracovnej neschopnosti, nevyhnutného liečenia úrazu, smrti následkom úrazu, alebo trvalých následkov úrazu'),
  INSURANCE_IPID_25_5_FINAL: t('Skupinové úrazové poistenie - Informačný dokument o poistnom produkte'),
  INSURANCE_OPP_ILOE: t('Poistné podmienky pre pripoistenie pre prípad nedobrovoľnej straty zamestnania "Credit Life"'),
  INSURANCE_ENVENT_NOTICE: t('Poistné hlásenie C Vyhlásenie osoby uplatňujúcej si nárok'),
  INSURANCE_IMPORTANT_CONDITIONS_NOTES: t('Dokument o dôležitých zmluvných podmienkach uzatváranej poistnej zmluvy poistenia schopnosti splácať pôžičku'),
  INSURANCE_COVERAGE_OVERVIEW: t('Prehľad poistného krytia'),
  INSURANCE_GENERAL_CONTRACT_INFO: t('Všeobecné poistné podmienky poistenia "Credit Life", Osobitné poistné podmienky pre pripoistenie pre prípad úplnej trvalej invalidity "Credit Life", Osobitné poistné podmienky pre pripoistenie pre prípad úplnej dočasnej invalidity "Credit Life"'),
  INSURANCE_GENERAL_CONTRACT: t('Rámcová poistná zmluva pre poistenie schopnosti splácať pôžičku '),
  BANK_ACCOUNT_STATEMENT_1: t('Výpis z bankového účtu 1'),
  BANK_ACCOUNT_STATEMENT_2: t('Výpis z bankového účtu 2'),
  PAYROLL_STATEMENT_1: t('Výplatná páska 1'),
  PAYROLL_STATEMENT_2: t('Výplatná páska 2'),
  OTHER: t('Iné'),
  INFORMATION_OBLIGATIONS_DEBTOR: t('Informačné povinnosti poskytovateľa služieb'),
  INFORMATION_OBLIGATIONS_INVESTOR: t('Informačné povinnosti poskytovateľa služieb'),
};



// WEBPACK FOOTER //
// ./src/common/enums/contractType.js